import React, { useState } from "react";
import { Aside, ListActionButtonProps, Stack } from "sprint-common-web";

import { EditListButton } from "../../../../common/components/buttons/EditListButton";
import { FramerateProfileListingItem } from "../../context/FramerateProfilesListingItem";
import { EditFramerateProfileForm } from "../forms/edit/EditFramerateProfileForm";

export const EditFramerateProfileButton: React.FC<ListActionButtonProps<FramerateProfileListingItem>> = (
    props: ListActionButtonProps<FramerateProfileListingItem>
) => {
    const { disabled, itemId } = props;
    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(false);
    const isButtonDisabled = disabled;

    const openAside = () => {
        setIsAsideOpen(true);
    };

    const closeAside = () => {
        setIsAsideOpen(false);
    };

    const handleFormSubmit = () => {
        closeAside();
    };

    return (
        <>
            <EditListButton onClick={openAside} disabled={isButtonDisabled} />
            <Aside type={"form"} isOpen={isAsideOpen} headerText="Edit Framerate Profile" onDismiss={closeAside}>
                <Stack>
                    <EditFramerateProfileForm onCancel={closeAside} onSubmit={handleFormSubmit} itemId={itemId} />
                </Stack>
            </Aside>
        </>
    );
};
